import { formatBool } from '@/utils/shared';

const CONFIG_COLUMN_TYPES = Object.freeze({
  'BOOLEAN': formatBool
});

export default CONFIG_COLUMN_TYPES;
